<template>
  <v-container class="my-12 px-4">
    <v-row justify="center">
      <v-col cols="12" class="px-2 text-center">
        <h1>
          {{ $t("common:errorMessage.accessDenied.text", "Access denied") }}
        </h1>
        <small>{{
          $t(
            "common:errorMessage.noPermission.text",
            "User does not have permission to access this page"
          )
        }}</small>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "UnauthorizedError"
};
</script>
